import { ReactNode, useEffect, useState } from 'react';
import { isLanguage, LANGUAGE_STORAGE_KEY, Language } from './language';
import { LanguageContext } from './context';

const getDefaultLanguage = (): Language => {
  if (typeof window === 'undefined') return 'tr';

  const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (isLanguage(saved)) return saved;

  return navigator.language.toLowerCase().startsWith('tr') ? 'tr' : 'en';
};

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<Language>(getDefaultLanguage);

  useEffect(() => {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
